module.exports = __webpack_public_path__ + "img/arrow-two-fingers-primary.3f2c3a0c.svg";